import {
    AfterViewInit,
    Component,
    EventEmitter,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { TemplatesPonListService } from "./templates-pon-list.service";
import {
    SelectedTemplateInfo,
} from "@nms-ng1/features/template/components/ui/templates-by-keywords/template-by-keyword-models";
import { NgModel } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { TemplatesByKeyword } from "./templates-pon-list.models";

/**
 * Componente responsável por exibir a lista de templates PON na tela
 * de GPON ONUs.
 */
@Component({
    selector: "templates-pon-list",
    templateUrl: "./templates-pon-list.component.html",
    styleUrls: ["./templates-pon-list.component.scss"]
})
export class TemplatesPonListComponent implements OnInit, AfterViewInit {

    panelOpenState: boolean;
    selectedTemplate: SelectedTemplateInfo;
    keywordsTemplates: TemplatesByKeyword[] = []
    searchTerm: string;

    @Output() onApplyTemplate: EventEmitter<SelectedTemplateInfo> = new EventEmitter<SelectedTemplateInfo>();
    @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
    @ViewChild("searchTermModel")
    searchTermModel: NgModel

    private originalKeywordsTemplates: TemplatesByKeyword[] = []

    constructor(private readonly templatesPonListService: TemplatesPonListService) { }

    async ngOnInit(): Promise<void> {
        this.originalKeywordsTemplates = await this.templatesPonListService.getTemplatesByKeywords();
        this.keywordsTemplates = _.cloneDeep(this.originalKeywordsTemplates);
    }

    ngAfterViewInit(): void {
        this.searchTermModel.valueChanges.pipe(debounceTime(500)).subscribe((value) => this.searchTemplate(value));
    }

    setSelected(template) {
        this.selectedTemplate = template;
    }

    tryOpenModal() {
        this.onApplyTemplate.emit(this.selectedTemplate);
    }

    cancel() {
        this.onCancel.emit();
    }

    private searchTemplate(value: string): void {
        this.setSelected(null);

        if (!value) {
            this.keywordsTemplates = _.cloneDeep(this.originalKeywordsTemplates);
            return;
        }

        const originalKeywordsTemplates: TemplatesByKeyword[] = _.cloneDeep(this.originalKeywordsTemplates);
        const filteredKeywordsTemplatesMap = {};

        originalKeywordsTemplates.forEach((keywordTemplate) => {
            keywordTemplate.templatesIdentifiers.forEach((templateIdentifier) => {
                if (templateIdentifier.label.toLowerCase().includes(value.toLowerCase())) {
                    if (!filteredKeywordsTemplatesMap[keywordTemplate.keyword]) {
                        filteredKeywordsTemplatesMap[keywordTemplate.keyword] = {
                            keyword: keywordTemplate.keyword,
                            templatesIdentifiers: [],
                            expanded: true
                        }
                    }
                    filteredKeywordsTemplatesMap[keywordTemplate.keyword].templatesIdentifiers.push(templateIdentifier);
                }
            });
        });

        this.keywordsTemplates = Object.values(filteredKeywordsTemplatesMap);
    }
}
